import { $authHost } from ".."

export const getDeliveryTypesAllAPI = async () => {
    const {data} = await $authHost.get(`api/delivery_types/all`)
    return data
}